import { getErrorReason, suppressableOperations, tableNotFoundError } from './getErrorReason';

export const shouldSuppressSnackbar = ({ operationName }, response) =>
  suppressableOperations.includes(operationName) && getErrorReason(response?.errors) === tableNotFoundError;
